/* eslint-disable import/no-anonymous-default-export */

import error from './de-DE/error';
import exception from './de-DE/exception';
import field from './de-DE/field';
import general from './de-DE/general';
import project from './de-DE/project';
import projectItem from './de-DE/projectItem';

export default {
  ...general,
  ...field,
  ...project,
  ...projectItem,
  ...error,
  ...exception,
};

